import { Link, animateScroll as scroll } from "react-scroll";

export default function HeroSection() {
  const scrollToContact = () => {
    scroll.scrollTo("Contact", {
      duration: 500,
      smooth: true,
      offset: -70,
      spy: true,
      activeClass: "navbar--active-content",
    });
  };
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="hero--badge">Hello, I'm Chris Chau</p>
          <h1 className="hero--section--title">
            <span className="hero--section--title--color">Software</span>
            <span className="hero--section--title--solid">Developer</span>
          </h1>
          <p className="hero--section-description">
            CS graduate from BYU (2025) specializing in full-stack and AI-powered applications. Currently leading development of "Lia" at More Good Foundation using React, Node.js, LangChain, and RAG.
          </p>
        </div>
        
        <Link
          to="Contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={-70}
          activeClass="navbar--active-content"
        >
          <button className="btn btn-primary" onClick={scrollToContact}>
            Get In Touch
          </button>
        </Link>
      </div>
      <div className="hero--section--img">
        <img src="./img/avatar.jpg" alt="Hero Section" />
      </div>
    </section>
  );
}
